import i18next, { t } from "i18next";
import React from "react";
import { Bar } from "react-chartjs-2";
import ChartJS from "chart.js/auto";

const labels = [
  {
    header: t("summary_screen.mindset"),
    subHeader: t("summary_screen.entrepreneur"),
  },
  {
    header: t("summary_screen.motivation"),
    subHeader: t("summary_screen.high"),
  },
  {
    header: t("summary_screen.time_for_freelancing"),
    subHeader: t("summary_screen.for_freelancing"),
  },
  {
    header: t("summary_screen.knowledge"),
    subHeader: t("summary_screen.beginner"),
  },
];

const lowColor = ["#FFBB00", "#EF6D44"];
const highColor = ["#419741", "#EFD344"];

const BarChart = ({ ratings }) => {
  const horizontalDottedLine = {
    id: "horizontalDottedLine",

    beforeDraw(chart) {
      const { ctx, chartArea, scales } = chart;
      ctx.imageSmoothingEnabled = true;

      const { width } = chartArea;
      const { x, y } = scales;
      ctx.save();

      labels.map((value, index) => {
        ctx.textAlign = "center";
        ctx.fillStyle = "#000000";
        ctx.font =
          i18next.language === "en"
            ? "bold 10px Open Sans"
            : "bold 9px Open Sans";
        ctx.fillText(
          value.header,
          x.getPixelForValue(index),
          y.getPixelForValue(0) + 15
        );

        ctx.textAlign = "center";
        ctx.fillStyle = "#989898";
        ctx.font =
          i18next.language === "en"
            ? "630 10.5px Open Sans"
            : "630 9.5px Open Sans";
        ctx.fillText(
          value.subHeader,
          x.getPixelForValue(index),
          y.getPixelForValue(0) + 28
        );
        return null;
      });

      ctx.strokeStyle = "#989898";
      ctx.lineWidth = 1;
      ctx.setLineDash([5, 10]);
      ctx.strokeRect(
        x.getPixelForValue(0) - 35,
        y.getPixelForValue(8),
        width,
        0
      );
      ctx.restore();

      ctx.fillStyle = "#989898";
      ctx.textAlign = "center";
      ctx.font = "normal 10px Open Sans";
      ctx.fillText("8", x.getPixelForValue(0) - 35, y.getPixelForValue(8) - 5);
    },
  };

  const data = {
    labels: labels,
    datasets: [
      {
        data: ratings,
        backgroundColor: (context, ...args) => {
          const value = context.dataset.data[context.dataIndex];
          const gradient = context.chart.ctx.createLinearGradient(0, 0, 0, 150);
          gradient.addColorStop(0, value >= 8 ? highColor[0] : lowColor[0]);
          gradient.addColorStop(1, value >= 8 ? highColor[1] : lowColor[1]);
          return gradient;
        },
        borderColor: "transparent",
        borderRadius: {
          topLeft: 3,
          topRight: 3,
          bottomLeft: 3,
          bottomRight: 3,
        },
        borderSkipped: false,
        barThickness: 30,
      },
    ],
  };
  const options = {
    responsive: true,
    animation: {
      duration: 2000,
      onComplete: function (props) {
        if (props.currentStep > 0) {
          ratings.map((value, index) => {
            props.chart.ctx.fillStyle = value >= 8 ? "#419741" : "#FF0000";
            props.chart.ctx.font = "normal 10px Open Sans";
            props.chart.ctx.fillText(
              value,
              props.chart.scales.x.getPixelForValue(index) - 8,
              props.chart.scales.y.getPixelForValue(value) - 5
            );
            props.chart.ctx.fillStyle = "#989898";
            props.chart.ctx.font = "normal 10px Open Sans";
            props.chart.ctx.fillText(
              "/10",
              value.toString().length >= 3
                ? props.chart.scales.x.getPixelForValue(index) + 8
                : props.chart.scales.x.getPixelForValue(index) + 5,
              props.chart.scales.y.getPixelForValue(value) - 5
            );
            return null;
          });
        }
      },
      onProgress: function (props) {
        if (props.currentStep >= 0) {
          props.chart.ctx.fillStyle = ratings[0] >= 8 ? "#419741" : "#FF0000";
          props.chart.ctx.font = "normal 10px Open Sans";
          props.chart.ctx.fillText(
            ratings[0],
            props.chart.scales.x.getPixelForValue(0) - 8,
            props.chart.scales.y.getPixelForValue(ratings[0]) - 5
          );
          props.chart.ctx.fillStyle = "#989898";
          props.chart.ctx.font = "normal 10px Open Sans";
          props.chart.ctx.fillText(
            "/10",
            ratings[0].toString().length >= 3
              ? props.chart.scales.x.getPixelForValue(0) + 8
              : props.chart.scales.x.getPixelForValue(0) + 5,
            props.chart.scales.y.getPixelForValue(ratings[0]) - 5
          );
        }
        if (props.currentStep >= 500) {
          props.chart.ctx.fillStyle = ratings[1] >= 8 ? "#419741" : "#FF0000";
          props.chart.ctx.font = "normal 10px Open Sans";
          props.chart.ctx.fillText(
            ratings[1],
            props.chart.scales.x.getPixelForValue(1) - 8,
            props.chart.scales.y.getPixelForValue(ratings[1]) - 5
          );
          props.chart.ctx.fillStyle = "#989898";
          props.chart.ctx.font = "normal 10px Open Sans";
          props.chart.ctx.fillText(
            "/10",
            ratings[1].toString().length >= 3
              ? props.chart.scales.x.getPixelForValue(1) + 8
              : props.chart.scales.x.getPixelForValue(1) + 5,
            props.chart.scales.y.getPixelForValue(ratings[1]) - 5
          );
        }
        if (props.currentStep >= 1000) {
          props.chart.ctx.fillStyle = ratings[2] >= 8 ? "#419741" : "#FF0000";
          props.chart.ctx.font = "normal 10px Open Sans";
          props.chart.ctx.fillText(
            ratings[2],
            props.chart.scales.x.getPixelForValue(2) - 8,
            props.chart.scales.y.getPixelForValue(ratings[2]) - 5
          );
          props.chart.ctx.fillStyle = "#989898";
          props.chart.ctx.font = "normal 10px Open Sans";
          props.chart.ctx.fillText(
            "/10",
            ratings[2].toString().length >= 3
              ? props.chart.scales.x.getPixelForValue(2) + 8
              : props.chart.scales.x.getPixelForValue(2) + 5,
            props.chart.scales.y.getPixelForValue(ratings[2]) - 5
          );
        }
        if (props.currentStep >= 1500) {
          props.chart.ctx.fillStyle = ratings[3] >= 8 ? "#419741" : "#FF0000";
          props.chart.ctx.font = "normal 10px Open Sans";
          props.chart.ctx.fillText(
            ratings[3],
            props.chart.scales.x.getPixelForValue(3) - 8,
            props.chart.scales.y.getPixelForValue(ratings[3]) - 5
          );
          props.chart.ctx.fillStyle = "#989898";
          props.chart.ctx.font = "normal 10px Open Sans";
          props.chart.ctx.fillText(
            "/10",
            ratings[3].toString().length >= 3
              ? props.chart.scales.x.getPixelForValue(3) + 8
              : props.chart.scales.x.getPixelForValue(3) + 5,
            props.chart.scales.y.getPixelForValue(ratings[3]) - 5
          );
        }
      },
      delay: (context) => {
        let delay = context.dataIndex * 500;
        return delay;
      },
    },
    layout: {
      padding: {
        left: 20,
        right: 20,
        top: 10,
        bottom: 40,
      },
    },
    plugins: {
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },

    scales: {
      x: {
        display: false,
      },
      y: {
        display: false,
      },
    },
    events: [],
  };

  return <Bar data={data} options={options} plugins={[horizontalDottedLine]} />;
};

export default BarChart;
